import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import { useGoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ disabled, onSuccess, onError }) => {
  const triggerGoogleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: ({ code }) => onSuccess(code),
    onError,
  });

  return (
    <Button
      fullWidth
      variant="outlined"
      disabled={disabled}
      onClick={() => triggerGoogleLogin()}
      startDecorator={
        <Box
          component="img"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          sx={{ width: 18, height: 18 }}
        />
      }
      sx={{
        '--Button-radius': '10px',
        minHeight: '48px',
        fontSize: '0.95rem',
        fontWeight: 500,
        letterSpacing: '0.02em',
        borderColor: 'rgba(255,255,255,0.15)',
        color: 'neutral.100',
        backgroundColor: 'rgba(255,255,255,0.04)',
        transition: 'all 0.25s ease',
        '&:hover': {
          borderColor: 'rgba(255,255,255,0.3)',
          backgroundColor: 'rgba(255,255,255,0.08)',
          transform: 'translateY(-1px)',
        },
        '&:active': { transform: 'translateY(0)' },
      }}
    >
      Sign in with Google
    </Button>
  );
};

export default GoogleLoginButton;
